import Splide from '@splidejs/splide';

export const initReviewsCarousel = () => {
  const caseStudiesReviewsSliderEl = document.querySelector(
    '[data-smart-home-control-reviews-slider]'
  );

  new Splide(caseStudiesReviewsSliderEl, {
    type: 'slide',
    perPage: 1,
    perMove: 1,
    speed: 500,
    rewind: true,
    arrows: false,
    pagination: true,
    classes: {
      pagination:
        'splide__pagination smart-home-control-reviews__slider-pagination',
      page: 'splide__pagination__page smart-home-control-reviews__slider-pagination-btn',
    },
  }).mount();
};
